import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import './index.css'
import App from './App.tsx'

// Expose environment variables for E2E testing
if (import.meta.env.MODE === 'production' || import.meta.env.MODE === 'development') {
  window.ENV = {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_WS_URL: import.meta.env.VITE_WS_URL,
    VITE_APP_NAME: import.meta.env.VITE_APP_NAME,
    VITE_MAX_PROXIMITY_RANGE: import.meta.env.VITE_MAX_PROXIMITY_RANGE,
    VITE_DEFAULT_MAP_ZOOM: import.meta.env.VITE_DEFAULT_MAP_ZOOM,
    VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT
  }
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
